<template>
  <div>
    <Header title="成绩认定"></Header>
    <div class="sub_succeed">
      <div style="color: #757DA3;font-size: 24px;line-height: 35px;" v-if="schoolCode != '12763'">提交成功</div>
      <div style="color: #757DA3;font-size: 24px;line-height: 35px;" v-else>{{this.$route.query.msg }}</div>
      <p style="color: #757DA3;font-size: 16px;line-height: 22px;">您的提交已送达管理端，请等待通知。</p>
      <div class="icon_succeed"></div>
    </div>
    <div class="sub_succeed_foot">
      <button class="back_btn" @click="back()">知道了</button>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        schoolCode : sessionStorage.getItem("schoolCode")
      }
    },
    methods:{
        back(){
          this.$router.push("/student/score_Affirmation");
        }
    }

  }
</script>

<style lang="less" scoped>
  .sub_succeed{padding:20px 40px;box-sizing: border-box;}
  .sub_succeed .icon_succeed{width: 120px;height: 120px;background: url(../../../../static/img/succeed.png) no-repeat center center;background-size: contain;margin: 60px auto;}
  .back_btn{width: 100%;height:44px;background:rgba(116,105,248,1);border-radius:3px;color: @attendance-color-3;font-size: 16px;}
  .sub_succeed_foot{width: 100%;padding: 0 20px;box-sizing: border-box;position: fixed;bottom: 40px;}
</style>



// WEBPACK FOOTER //
// src/components/student/Score/submit_success.vue